module.exports = __webpack_public_path__ + "static/media/logo.f4f2df24.png";